import { observer } from "mobx-react";
import { useStores } from "hooks/useStores";
import {Button, Variant} from "../../../Button";
import {Uppercase} from "../../../../styles/components";
import {Text1, Title1} from "../../../../styles/business-components";
import * as S from './styles'

import Image from '../../../../assets/images/business/b_m_cnt10_img1.png'
import Image2 from '../../../../assets/images/business/b_m_cnt10_img2.png'

export const Content10 = observer(() => {

  const { businessStore } = useStores();

  return (
    <S.CustomContainer>
        <Title1>
            Интуитивное администрирование - понятное управление пользователями
        </Title1>
        <S.Content>
            <S.ImageBlock>
                <S.Image src={Image}/>
                <S.Image2 src={Image2}/>
            </S.ImageBlock>
            <S.TextBlock>
                <S.Text>
                    Здесь можно управлять пользователями и выполнять начальные настройки.
                    Управление пользователями полностью и исключительно в ваших руках.
                    Только ваши администраторы имеют возможность управлять входом и выходом сотрудников в TeleGuard Business.
                </S.Text>
                <Button variant={Variant.Business} onClick={businessStore.toggleFeedback}><Uppercase>Попробовать Прямо сейчас</Uppercase></Button>
            </S.TextBlock>
        </S.Content>
    </S.CustomContainer>
  )
})